import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoryMasterService {

  constructor(private http: HttpClient,
    private httpService: HttpService) { }

getCategoryList() {
    // return this.http.get(environment.pssUrl + 'categoryMaster/', )
    //     .map(res => res.json());

    var request = {
        URL: "categoryMaster/"
    }
    return this.httpService.get(request);
}

getCategoryListByMeetingTypeID(meetingTypeID) {
    // return this.http.get(environment.pssUrl + 'categoryMeetingTypeMaster/'+meetingTypeID )
    //     .map(res => res.json());

    var request = {
        URL: "categoryMeetingTypeMaster/" + meetingTypeID
    }
    return this.httpService.get(request);
}

addCategory(newCategory) {

    var request = {
        URL: "categoryMaster/addcategory",
        DATA: newCategory
    }
    return this.httpService.post(request);
}
updateCategory(data) {
    const token = localStorage.getItem('token') || '';
    var PSSDetail = localStorage.getItem('companyDetails');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token,
      'PSSDetail': PSSDetail || ''
    });
  
    return this.http.post(environment.pssServerUrl + 'categoryMaster/editCategory', data, { headers });
  }
  

getCategoryById(categoryId: string) {

    var companyID = JSON.parse(localStorage.getItem("companyDetails")).companyID;
    var request = {
        URL: "categoryMaster/" + companyID + "/" + categoryId
    }
    return this.httpService.get(request);

}



deleteCategory(categoryId) {
    // var headers = new Headers();
    // headers.append('Content-Type', 'application/json');
    // var token = localStorage.getItem('token')
    // headers.append("x-access-token", token)
    // return this.http.post(environment.pssUrl + 'categoryMaster/deleteCategory/' + categoryId, { headers: headers })
    //     .map(res => res.json());

    var request = {
        URL: 'categoryMaster/deleteCategory/' + categoryId,
        DATA: {}
    }
    return this.httpService.post(request);
}

getMeetingTypeList() {
    // return this.http.get(environment.pssUrl + 'meetingType/')
    //     .map(res => res.json());

    var request = {
        URL: "meetingType/"
    }
    return this.httpService.get(request);
}
getMeetingNameById(meetingTypeId) {
    var request = {
        URL: "getMeetingNameById/" + meetingTypeId
    }
    return this.httpService.get(request);
}
}